import { Redirect } from 'expo-router';

import { PendingSubmittedOrderRecovery } from 'components/pending-submitted-order-recovery';
import { CheckoutV2ExperimentLoading } from 'experiments/checkout-v2/checkout-v2-experiment-loading';
import CheckoutPage from 'experiments/checkout-v2/treatment/features/checkout/pages';
import { useCheckoutV2ExperimentGate } from 'experiments/checkout-v2/use-enable-checkout-v2-experiment';
import { routes } from 'utils/routing';

export default function Checkout() {
  const { isReady, isTreatment } = useCheckoutV2ExperimentGate();

  if (!isReady) {
    return <CheckoutV2ExperimentLoading />;
  }

  if (!isTreatment) {
    return <Redirect href={routes.cart} />;
  }

  return (
    <>
      <CheckoutPage />
      <PendingSubmittedOrderRecovery checkoutRoute={routes.cartCheckout} />
    </>
  );
}
